import React from "react";

import { statesLookup } from "common/constants/states";

const USState = ({ stateId }) => <span>{statesLookup[stateId].label}</span>;

export default USState;
